import LogoImg from 'img/esd.png';
import React from 'react';

export const LogoComponent = ({ className }: { className?: string }) => (
  <img className={className} src={LogoImg} alt="esd.next" />
);

export default LogoComponent;
